"use client";

// AdsServiceIntro از سرور رندر می‌شود؛ import مستقیم AdsRequestButton کل فرم‌ساز core (موتور فرم، فیلدها و CSS)
// را به چانک مشترک همه‌ی صفحه‌ها می‌برد. این مرز client آن را در چانک جدا نگه می‌دارد.
import dynamic from "next/dynamic";

const AdsRequestButton = dynamic(() => import("./AdsRequestButton"));

export default AdsRequestButton;
